import React, { useState , useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import './refundstatus.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

const RefundStatus = () => {


      useEffect(() => {
    // Scroll to the top when the page is loaded
    window.scrollTo(0, 0);
  }, []);



  const [activeTab, setActiveTab] = useState("state"); // default tab: state refund

  const mainLinks = [
    { name: "Federal Refund Status", link: "https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp", text: "Check Here" },
    { name: "State Refund Status", link: "#state-refunds", text: "Check Here" },
    { name: "Pay Federal Taxes Online", link: "https://www.irs.gov/payments", text: "Pay Here" },
    { name: "Pay State Taxes Online", link: "https://www.officialpayments.com/index.jsp", text: "Pay Here" },
  ];

  const stateLinks = [
    { state: "Alabama (AL)", link: "https://myalabamataxes.alabama.gov/_" },
    { state: "Alaska (AK)", link: "None - Tax free" },
    { state: "Arizona (AZ)", link: "https://www.aztaxes.gov/Home/Login?aspxerrorpath=/Individual/CheckRefund.aspx" },
    { state: "Arkansas (AR)", link: "https://atap.arkansas.gov/_/#1" },
    { state: "California (CA)", link: "https://www.ftb.ca.gov/refund/index.asp?WT.mc_id=akRefund" },
    { state: "Colorado (CO)", link: "https://www.colorado.gov/revenueonline/_/#1" },
    { state: "Connecticut (CT)", link: "https://portal.ct.gov/DRS/Individuals/Income-Tax-Refunds" },
    { state: "Delaware (DE)", link: "https://de.gov/refundstatus" },
    { state: "Florida (FL)", link: "None - Tax free" },
    { state: "Georgia (GA)", link: "https://etax.dor.ga.gov/_/" },
    { state: "Hawaii (HI)", link: "https://tax.hawaii.gov/geninfo/refund/" },
    { state: "Idaho (ID)", link: "https://tax.idaho.gov/i-1040-refund-status.cfm" },
    { state: "Illinois (IL)", link: "https://www.idor.illinois.gov/taxstatus" },
    { state: "Indiana (IN)", link: "https://www.in.gov/dor/tax-returns/" },
    { state: "Iowa (IA)", link: "https://tax.iowa.gov/individual-income-tax-refund-status" },
    { state: "Kansas (KS)", link: "https://www.kdor.ks.gov/tap" },
    { state: "Kentucky (KY)", link: "https://refunds.kentucky.gov/" },
    { state: "Louisiana (LA)", link: "https://www.revenue.louisiana.gov/Refunds" },
    { state: "Maine (ME)", link: "https://www.maine.gov/revenue/taxrelief/RefundStatus" },
    { state: "Maryland (MD)", link: "https://marylandtaxes.gov/" },
    { state: "Massachusetts (MA)", link: "https://www.mass.gov/service-details/check-the-status-of-your-tax-refund" },
    { state: "Michigan (MI)", link: "https://www.michigan.gov/taxes/individual-income-tax/refunds" },
    { state: "Minnesota (MN)", link: "https://www.revenue.state.mn.us/individual-income-tax-refund-status" },
    { state: "Mississippi (MS)", link: "https://www.dor.ms.gov/" },
    { state: "Missouri (MO)", link: "https://mydor.mo.gov/" },
    { state: "Montana (MT)", link: "https://mt.gov/revenue/refundstatus/" },
    { state: "Nebraska (NE)", link: "https://revenue.nebraska.gov/" },
    { state: "Nevada (NV)", link: "None - Tax free" },
    { state: "New Hampshire (NH)", link: "None - Tax free" },
    { state: "New Jersey (NJ)", link: "https://www.state.nj.us/treasury/taxation/" },
    { state: "New Mexico (NM)", link: "https://www.tax.newmexico.gov/individuals/" },
    { state: "New York (NY)", link: "https://www.tax.ny.gov/" },
    { state: "North Carolina (NC)", link: "https://www.ncdor.gov/taxes" },
    { state: "North Dakota (ND)", link: "https://www.nd.gov/tax/individual-income-tax/refund-status" },
    { state: "Ohio (OH)", link: "https://tax.ohio.gov/wps/portal/gov/tax/business/individual-income-tax-refund-status" },
    { state: "Oklahoma (OK)", link: "https://oklahoma.gov/tax" },
    { state: "Oregon (OR)", link: "https://www.oregon.gov/dor/individuals/pages/refund-status.aspx" },
    { state: "Pennsylvania (PA)", link: "https://www.revenue.pa.gov/" },
    { state: "Rhode Island (RI)", link: "https://www.tax.ri.gov/" },
    { state: "South Carolina (SC)", link: "https://www.sctax.org/" },
    { state: "South Dakota (SD)", link: "None - Tax free" },
    { state: "Tennessee (TN)", link: "None - Tax free" },
    { state: "Texas (TX)", link: "None - Tax free" },
    { state: "Utah (UT)", link: "https://tax.utah.gov/" },
    { state: "Vermont (VT)", link: "https://tax.vermont.gov/" },
    { state: "Virginia (VA)", link: "https://www.tax.virginia.gov/refund-status" },
    { state: "Washington (WA)", link: "None - Tax free" },
    { state: "West Virginia (WV)", link: "https://www.tax.wv.gov/" },
    { state: "Wisconsin (WI)", link: "https://www.revenue.wi.gov/" },
    { state: "Wyoming (WY)", link: "None - Tax free" }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "federal":
        return (
          <div className="li-prices-comparison-section">
            <div className="li-comparison-table">
              <div className="li-table-header">
                <div className="li-table-column">Federal Refund Status</div>
                <div className="li-table-column">Link</div>
              </div>
              <div className="li-comparison-row">
                <div className="li-table-column li-service-name">Federal Refund Status</div>
                <div className="li-table-column li-price">
                  <a href={mainLinks[0].link} target="_blank" rel="noopener noreferrer">
                    Check Here
                    <FontAwesomeIcon icon={faLink} className="refund-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      case "state":
  return (
    <div className="li-prices-comparison-section">
      <div className="li-comparison-table">
        <div className="li-table-header">
          <div className="li-table-column">State</div>
          <div className="li-table-column">Links</div>
        </div>
        {stateLinks.map((item, index) => (
          <div className="li-comparison-row" key={index}>
            <div className="li-table-column li-service-name">{item.state}</div>
            <div className="li-table-column li-price">
              {item.link === "None - Tax free" ? (
                <span className="tax-free-text">None - Tax free</span>
              ) : (
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  Check Here
                  <FontAwesomeIcon icon={faLink} className="refund-icon" />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>

        );
      case "payFederal":
        return (
          <div className="li-prices-comparison-section">
            <div className="li-comparison-table">
              <div className="li-table-header">
                <div className="li-table-column">Pay Federal Taxes Online</div>
                <div className="li-table-column">Link</div>
              </div>
              <div className="li-comparison-row">
                <div className="li-table-column li-service-name">Pay Federal Taxes Online</div>
                <div className="li-table-column li-price">
                  <a href={mainLinks[2].link} target="_blank" rel="noopener noreferrer">
                    Pay Here
                    <FontAwesomeIcon icon={faLink} className="refund-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      case "payState":
        return (
          <div className="li-prices-comparison-section">
            <div className="li-comparison-table">
              <div className="li-table-header">
                <div className="li-table-column">Pay State Taxes Online</div>
                <div className="li-table-column">Link</div>
              </div>
              <div className="li-comparison-row">
                <div className="li-table-column li-service-name">Pay State Taxes Online</div>
                <div className="li-table-column li-price">
                  <a href={mainLinks[3].link} target="_blank" rel="noopener noreferrer">
                    Pay Here
                    <FontAwesomeIcon icon={faLink} className="refund-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <NavBar />
      
      <div className="li-prices-comparison-container">
        <div className="li-comparison-header">
          <h2>Tax Refund Status & Payment Links</h2>
        </div>

        <div className="tabs-header">
          <button className={activeTab === "state" ? "tab active" : "tab"} onClick={() => setActiveTab("state")}>Check State Refund Status</button>
          <button className={activeTab === "federal" ? "tab active" : "tab"} onClick={() => setActiveTab("federal")}>Check Federal Refund Status</button>
          <button className={activeTab === "payFederal" ? "tab active" : "tab"} onClick={() => setActiveTab("payFederal")}>Pay Federal Taxes</button>
          <button className={activeTab === "payState" ? "tab active" : "tab"} onClick={() => setActiveTab("payState")}>Pay State Taxes</button>
        </div>

        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default RefundStatus;